import * as api from 'dashboard/resources/big-winners.api';
import actionTypes from './action-types';

export const fetchBigWinnersHistoryRequest = () => ({
  type: actionTypes.FETCH_BIG_WINNERS_HISTORY_REQUEST,
  name: 'bigWinnersStatusLoadingStatus',
});

export const fetchBigWinnersHistorySuccess = (items, pagination) => ({
  type: actionTypes.FETCH_BIG_WINNERS_HISTORY_SUCCESS,
  name: 'bigWinnersStatusLoadingStatus',
  items,
  pagination,
});

export const fetchBigWinnersHistoryFailure = () => ({
  type: actionTypes.FETCH_BIG_WINNERS_HISTORY_FAILURE,
  name: 'bigWinnersStatusLoadingStatus',
});

export const fetchBigWinnersHistory = (params) => async (dispatch, getState) => {
  try {
    const { session } = getState();
    const { locale } = session;
    const retailerId = params.filters.retailerId || session.retailer.retailerId;
    const queryParams = {
      ...params,
      locale,
    };

    dispatch(fetchBigWinnersHistoryRequest());
    const { content, ...pagination } = await api.fetchBigWinnersHistory(queryParams, retailerId);
    dispatch(fetchBigWinnersHistorySuccess(content, pagination));
  } catch (error) {
    console.error('FETCH_BIG_WINNERS_HISTORY', error);
    dispatch(fetchBigWinnersHistoryFailure());
  }
};

export const downloadBigWinnersHistoryReportRequest = () => ({
  type: actionTypes.DOWNLOAD_BIG_WINNERS_HISTORY_REPORT_REQUEST,
});

export const downloadBigWinnersHistoryReportSuccess = () => ({
  type: actionTypes.DOWNLOAD_BIG_WINNERS_HISTORY_REPORT_SUCCESS,
});

export const downloadBigWinnersHistoryReportFailure = () => ({
  type: actionTypes.DOWNLOAD_BIG_WINNERS_HISTORY_REPORT_FAILURE,
});

export const downloadBigWinnersHistoryReport = (params, extension) => (dispatch, getState) => {
  try {
    const { session } = getState();
    const { locale } = session;
    const retailerId = params.retailerId || session.retailer.retailerId;

    const queryParams = {
      ...params,
      locale,
    };

    dispatch(downloadBigWinnersHistoryReportRequest());
    dispatch(downloadBigWinnersHistoryReportSuccess());
    return api.downloadBigWinnersHistoryReport(queryParams, retailerId, extension);
  } catch (error) {
    console.error('DOWNLOAD_EARNINGS_HISTORY_REPORT', error);
    dispatch(downloadBigWinnersHistoryReportFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/big-winners/big-winners.actions.js